import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HttpClientModule } from '@angular/common/http';
import { IntegrationComponent } from './integration/integration.component';
import { SitesBuilderLibModule } from '@3ddv/ngx-sites-builder-lib';
import { LoginComponent } from './login/login.component';
import { CookiesCenterComponent } from './cookies-center/cookies-center.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    IntegrationComponent,
    LoginComponent,
    CookiesCenterComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SitesBuilderLibModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
